// Hidden anti-spam trap field. Real visitors never see or fill this;
// bots that auto-fill every input on the page will, letting the backend
// silently discard the submission.
const HoneypotField = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", overflow: "hidden" }}>
    <label htmlFor="website">Leave this field empty</label>
    <input
      id="website"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default HoneypotField;
